import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"home\"><path d=\"M941.44 504.64L534.4 73.792a30.336 30.336 0 00-44.736 0L82.624 504.64A69.12 69.12 0 0064 552.064c0 36.992 28.352 67.008 63.232 67.008h42.88v307.456c0 18.56 14.144 33.472 31.68 33.472h246.976V725.504h110.72V960h262.784a32.576 32.576 0 0031.616-33.472V619.072h42.88c16.832 0 32.896-7.04 44.8-19.712a69.888 69.888 0 00-.128-94.72z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol